import { useCallback, useMemo } from "react";

import { InvestmentProposal, InvestmentProposalHistory } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";

import { useProposalDetails } from "./useProposalDetails";

export type InvestmentProposalWithHistory = InvestmentProposal & {
  history_investment_proposals?: InvestmentProposalHistory[];
};

interface UseGetInvestmentProposalDetailsOptions {
  includeHistory?: boolean;
}

export const useGetInvestmentProposalDetails = (id?: number, options?: UseGetInvestmentProposalDetailsOptions) => {
  const includeHistory = options?.includeHistory ?? true;
  const fp = useMemo(() => PropallyApiFactory(), []);
  const fetchProposal = useCallback(async (proposalId: number) => {
    const response = await fp.v1InvestmentProposalsInvestmentProposalIdGet(proposalId, includeHistory, {
      withCredentials: true,
    });
    return { status: response.status, data: response.data as InvestmentProposalWithHistory };
  }, [fp, includeHistory]);
  const { refetch, ...state } = useProposalDetails(id, fetchProposal);
  return { ...state, fetchInvestmentProposalById: refetch };
};
